'use client';

import React, { useState } from 'react';

import HighlightsSection from '@/app/[locale]/(default-layout)/specials/_components/HighlightsSection';
import SpecialsHeroContent, {
    HighlightItem
} from '@/app/[locale]/(default-layout)/specials/_components/SpecialsHeroContent';

import CenterLayout from '@cineamo/composables/src/CenterLayout';

type SpecialsHeroWithHighlightsProps = Readonly<{
    highlights: HighlightItem[];
}>;

export default function SpecialsHeroWithHighlights({ highlights }: SpecialsHeroWithHighlightsProps): React.JSX.Element {
    const [selectedIndex, setSelectedIndex] = useState(0);

    return (
        <>
            <SpecialsHeroContent
                highlights={highlights}
                selectedIndex={selectedIndex}
                onSelectHighlight={setSelectedIndex}
            />
            <CenterLayout>
                <div className="py-32">
                    <HighlightsSection
                        highlights={highlights}
                        activeHighlightIndex={selectedIndex}
                        onHighlightSelect={setSelectedIndex}
                    />
                </div>
            </CenterLayout>
        </>
    );
}
